// A tiny registry of currently-live session stores, keyed by id. It lets global
// UI (the sidebar) act on a session that happens to be open right now: renaming
// the live store updates the header AND persists in step (attachPersistence
// watches the title), instead of writing IndexedDB underneath the active store
// and getting clobbered by its next save. The controller registers on create and
// unregisters on dispose.

import type { SessionStore } from './sessionStore'

const stores = new Map<string, SessionStore>()

export const liveSessions = {
  register(store: SessionStore): void {
    stores.set(store.getSnapshot().id, store)
  },
  unregister(id: string): void {
    stores.delete(id)
  },
  get(id: string): SessionStore | undefined {
    return stores.get(id)
  }
}
